import React from 'react';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import AppRouter from './AppRouter';
import { CurrentEnvironment, Environment } from './Environment';

const App: React.FC = () => {
    return (
        <>         
            <AppRouter />
            {(CurrentEnvironment !== Environment.Production) && <ReactQueryDevtools initialIsOpen={false} />}
        </>
    );
};

export default App;